import { get } from '../libs/Axios';
import BaseComponent from '../abstracts/BaseComponent';
import { DataLayerUtils } from '../utilities/DataLayer';

export default class SelectSizeComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.ADDTOCART_EVENTS.erros]: this.showError,
      [this.CUSTOM_MESSAGES.RENT_DURATION_EVENTS.changed]: this.setDuration
    };
  }

  get SELECTORS() {
    return {
      itemSize: '.item-size input',
      errorMessage: '.js-error',
      body: document.body
    };
  }

  get CLASSES() {
    return {
      hide: 'hide'
    };
  }

  constructor(element) {
    super(element);
    this.selectedEvent = this.$options.wishlist ? this.CUSTOM_MESSAGES.SELECT_SIZE_EVENTS.selectedWishlist : this.CUSTOM_MESSAGES.SELECT_SIZE_EVENTS.selected;
    this.getDuration();
    this.checkSizeAvailability();
    this.handleChange();
  }

  setDuration({ value }) {
    this.duration = value;
  }

  async checkSizeAvailability() {
    const sizeSelected = [...this.$el.querySelectorAll('input[type="radio"]')].find(el => el.checked);

    if (sizeSelected) {
      const { data } = await this.getProductSizeVariation(sizeSelected.value, sizeSelected.getAttribute('data-size-value'));
      const { available, id } = data.product;

      if (!available) {
        this.$el.setAttribute('data-unavailable-pid', id);
        sizeSelected.checked = false;
        this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.show, {
          selector: this.$options.element,
          className: 'modal-50 not-full-height'
        });
      } else {
        this.EMIT(this.selectedEvent, {
          component: 'SelectSizeComponent',
          sizeSelected: sizeSelected.getAttribute('data-size-value'),
          product: data.product
        });
      }
    } else {
      this.EMIT(this.CUSTOM_MESSAGES.ADDTOCART_EVENTS.waitForMe, {
        component: 'SelectSizeComponent'
      });
    }
  }

  showError({ component }) {
    if (this.COMPONENT_NAME !== component) return false;
    const chooseSizeLabel = document.querySelector('.js-choose-size-error');
    const chooseSizeBorder = document.querySelector('.js-choose-size-error-border');
    chooseSizeLabel.classList.add('size-missing-error');
    chooseSizeBorder.classList.add('size-missing-error-border');
    chooseSizeLabel.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    });
  }

  handleChange() {
    this.$on('change.size', async (e) => {
      const sizeSelected = [...this.$el.querySelectorAll('input[type="radio"]')].find(el => el.checked);
      const { data } = await this.getProductSizeVariation(e.target.value, e.target.getAttribute('data-size-value'));
      const { available, id } = data.product;
      const chooseSizeLabel = document.querySelector('.js-choose-size-error');
      const chooseSizeBorder = document.querySelector('.js-choose-size-error-border');

      if (chooseSizeLabel) chooseSizeLabel.classList.remove('size-missing-error');
      if (chooseSizeBorder) chooseSizeBorder.classList.remove('size-missing-error-border');


      if (this.SELECTORS.body.hasAttribute('data-unavailable-size')) {
        this.SELECTORS.body.removeAttribute('data-unavailable-size');
      }

      if (!available) {
        sizeSelected.checked = false;
        this.SELECTORS.body.setAttribute('data-unavailable-size', e.target.getAttribute('data-size-value'));
        this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.close);
        this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.show, {
          selector: this.$options.pidselector || this.$options.element,
          className: 'modal-50 not-full-height'
        });
        var variantSelected = e.target.getAttribute('data-size-value');
        var pid = this.buildPid(variantSelected);
        DataLayerUtils.push({
          event: 'asyncAction',
          gaHitType: 'event',
          eventCategory: 'notify_me',
          eventAction: 'open',
          eventLabel: pid + '|' + variantSelected
        });
      } else {
        if (!this.$options.wishlist) {
          DataLayerUtils.push({
            gaHitType: 'event',
            event: 'pdp_interactions',
            eventCategory: 'pdp',
            eventAction: 'select_size',
            eventLabel: sizeSelected.getAttribute('data-size-value')
          });
        }

        this.EMIT(this.selectedEvent, {
          component: 'SelectSizeComponent',
          sizeSelected: sizeSelected.getAttribute('data-size-value'),
          product: data.product,
          pid: id
        });
      }
    });
  }

  getDuration() {
    if (!this.duration) {
      this.EMIT(this.CUSTOM_MESSAGES.RENT_DURATION_EVENTS.get);
    }
  }

  buildPid(size) {
    let pid = '';
    const durationInput = document.querySelectorAll('input[type="radio"][name="rent-duration"]');
    const basePid = this.$options.pid || document.querySelector('[data-pid]').getAttribute('data-pid');
    // TODO da rivedere, a volte duration manca ( undefined )
    if (!this.duration && durationInput.length > 0) {
      const durationSelected = [...durationInput].find(radio => radio.checked);
      this.duration = durationSelected.value;
    }
    switch (basePid.split('_').length) {
      case 3:
        pid = `${basePid}_${this.duration || 4}`;
        break;
      case 2:
        pid = `${basePid}_${size}_${this.duration || 4}`;
        break;
      default:
        pid = `${basePid}_${size}_${this.duration || 4}`;
        break;
    }

    return pid;
  }

  async getProductSizeVariation(url, size) {
    let res = null;
    const pid = this.buildPid(size);
    try {
      res = await get(url, {
        params: {
          pid
        }
      });
    } catch (e) {
      console.error(e);
    }

    return res;
  }
}
